import React from 'react';
import {Link, useNavigate} from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import styles from './BrandingFooter.module.css';
import { FiGrid } from 'react-icons/fi'; // Можно добавить иконку для красоты

const BrandingFooter = () => {

    const navigate = useNavigate();

    // 3. Создаем обработчик клика
    const handleNavigateHome = (e) => {
        e.preventDefault(); // На всякий случай предотвращаем стандартное поведение
        navigate('/'); // Даем прямую команду перейти на главную страницу
    };

    return (
        <footer className={styles.footer}>
            <a href="/" onClick={handleNavigateHome} className={styles.link}>
                <FormattedMessage id="footer.madeWith"/>
            </a>
            {/*<Link to="/" className={styles.link}>*/}
            {/*    /!* Можно добавить иконку перед текстом, например:*/}
            {/*        <FiGrid size={14} className={styles.icon} />*/}
            {/*    *!/*/}
            {/*    <FormattedMessage id="footer.madeWith"/>*/}
            {/*</Link>*/}
        </footer>
    );
};

export default BrandingFooter;
